import { LiftStationType, Pagination } from '@innovyze/shared-utils';

export interface ListStationsParams {
	offset?: string;
	limit?: string;
	searchQuery?: string;
	sortBy?: string;
	includeSensorGroups?: string;
	includeSensors?: string;
}

export interface LocationObject {
	latitude: number;
	longitude: number;
}
export type LocationArray = [number, number];
export type Location = LocationObject | LocationArray;

export interface LiftStationData {
	calculatedVolumeSensor?: string;
	outflowPipeDiameter?: number;
	wellThreshold: number;
	location: Location;
}

export interface SensorDataFromStation {
	_id: string;
	createDate: Date;
	createdBy: string;
	liftStationConfig: string;
	name?: string;
}

export interface SensorFromStation extends SensorDataFromStation {
	sensorId: string;
}

export interface SensorGroupFromStation extends SensorDataFromStation {
	sensorGroupId: string;
}

export interface CalculatedVolumeSensorFromStation
	extends SensorDataFromStation {
	calculatedVolumeSensorId: string;
}

export interface PaginatedSensorGroupsFromStation {
	pagination: Pagination;
	sensorGroups: SensorGroupFromStation[];
}

export interface PaginatedSensorsFromStation {
	pagination: Pagination;
	sensors: SensorFromStation[];
}

export interface LiftStation {
	_id: string;
	createdBy: string;
	lastModifiedBy: string;
	name: string;
	type: string;
	liftStationData: LiftStationData;
	createDate: Date;
	lastModifiedDate: Date;
	sensorGroups?: SensorGroupFromStation[];
	sensors?: SensorFromStation[];
	__v: number;
}

export interface LiftStationFormFields {
	_id?: string;
	name: string;
	type: string;
	sensorGroups?: string[];
	originalSensorGroups?: string[];
	sensors?: string[];
	originalSensors?: string[];
	location?: string;
	outflowPipeDiameter?: number;
	wellThreshold?: number;
	calculatedVolumeSensor?: string;
	images?: string[];
}
export interface PaginatedStations {
	pagination?: Pagination;
	stations?: LiftStation[];
	initialized: boolean;
	createdStation?: LiftStation;
}

export interface StationsStoreState {
	paginatedStations?: PaginatedStations;
	stationLocation?: Location;
	initialized: boolean;
	stationById: {
		initialized: boolean;
		station?: LiftStation;
	};
	sensorGroupsByStationId: {
		initialized: boolean;
		sensorGroups?: SensorGroupFromStation[];
	};
	sensorsByStationId: {
		initialized: boolean;
		sensors?: SensorFromStation[];
	};
	imagesByStationId: {
		initialized: boolean;
		images?: string[];
	};
	upsertLiftStation: {
		status: 'idle' | 'pending' | 'success' | 'error' | 'timeout';
	};
}

export interface StationImagesResponse {
	liftStationConfig?: string;
	_id?: string;
	images?: string[];
}

export const DEFAULT_FACILITY_TYPE: LiftStationType = 'Pump Station';
